var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"content",staticClass:"preview-text ellipsis",staticStyle:{"white-space":"pre-line"}})}
var staticRenderFns = []

export { render, staticRenderFns }